/**
 *
 * Asynchronously loads the component for PartnerAcceptInvite
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/PartnerAcceptInvite/loadable.js